export { default as Inductee3DHero } from './Inductee3DHero';